var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxsLeaf1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6758 6.25165L40.4557 3.94165L38.2558 4.67498C34.4853 5.98498 30.4591 6.38698 26.5041 5.84832C22.3482 5.20337 18.0944 5.77648 14.2574 7.49832C12.2233 8.36447 10.4381 9.72566 9.06445 11.458C7.69078 13.1903 6.77222 15.2387 6.39242 17.4166C5.89994 20.2302 6.14631 23.1235 7.10742 25.8133C7.72627 24.4165 8.44942 23.0682 9.27075 21.78C11.1338 19.0389 13.7153 16.8633 16.7324 15.4916C19.6391 14.1645 22.8161 13.5367 26.0091 13.6583C22.9695 14.1231 20.0599 15.2157 17.4657 16.8666C16.2145 17.6529 15.0685 18.5955 14.0557 19.6716C13.0871 20.7473 12.2331 21.9209 11.5074 23.1733C10.1444 25.7913 9.17453 28.5959 8.62908 31.4967C8.04116 34.4068 7.72204 37.3648 7.67575 40.3333H11.3424C11.5147 37.671 11.8762 35.0243 12.4241 32.4133C14.9677 33.7869 17.8202 34.4874 20.7107 34.4483C23.4066 34.4465 26.0748 33.9041 28.5574 32.8533C42.5091 26.895 40.6758 7.07665 40.6758 6.25165Z",
    fill: "#FFCE1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxsLeaf1);
export default __webpack_public_path__ + "static/media/bxs-leaf 1.223122e2ee150ef41769f76fa3578a6e.svg";
export { ForwardRef as ReactComponent };